/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `pending` - pending
 * * `sent` - sent
 * * `received` - received
 * * `started` - started
 * * `success` - success
 * * `failure` - failure
 * * `revoked` - revoked
 * @export
 */
export const RevisionTaskStatusEnum = {
  PENDING: "pending",
  SENT: "sent",
  RECEIVED: "received",
  STARTED: "started",
  SUCCESS: "success",
  FAILURE: "failure",
  REVOKED: "revoked",
} as const;
export type RevisionTaskStatusEnum =
  (typeof RevisionTaskStatusEnum)[keyof typeof RevisionTaskStatusEnum];

export function instanceOfRevisionTaskStatusEnum(value: any): boolean {
  for (const key in RevisionTaskStatusEnum) {
    if (Object.prototype.hasOwnProperty.call(RevisionTaskStatusEnum, key)) {
      if (RevisionTaskStatusEnum[key as keyof typeof RevisionTaskStatusEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function RevisionTaskStatusEnumFromJSON(json: any): RevisionTaskStatusEnum {
  return RevisionTaskStatusEnumFromJSONTyped(json, false);
}

export function RevisionTaskStatusEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RevisionTaskStatusEnum {
  return json as RevisionTaskStatusEnum;
}

export function RevisionTaskStatusEnumToJSON(value?: RevisionTaskStatusEnum | null): any {
  return value as any;
}

export function RevisionTaskStatusEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): RevisionTaskStatusEnum {
  return value as RevisionTaskStatusEnum;
}
